'use strict';

var App = require('app');

var Style = Backbone.Model.extend({
    url: '/api/v1/company/style',
});

var API = {
    getStyle: function () {
        var style = new Style({ id: 0 });
        var defer = $.Deferred();

        style.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('user:style', function () {
    return API.getStyle();
});

module.exports = Style;
